function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1992(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 27.73,
    height: 16.54,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.9729411764705882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 8.27,
    fontFamily: "Arial"
  }, "\n        Lake_of_the_Woods\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.54,
    width: 27.73,
    height: 16.56,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 24.82,
    fontFamily: "Arial"
  }, "\n        Red_Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 33.1,
    width: 27.73,
    height: 17.98,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 42.09,
    fontFamily: "Arial"
  }, "\n        Mahnomen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 51.08,
    width: 27.73,
    height: 18.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.33625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 60.425,
    fontFamily: "Arial"
  }, "\n        Traverse\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.77,
    width: 27.73,
    height: 19.7,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 79.61999999999999,
    fontFamily: "Arial"
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 89.47,
    width: 27.73,
    height: 22.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 100.695,
    fontFamily: "Arial"
  }, "\n        Kittson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 111.92,
    width: 27.73,
    height: 25.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.86
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 124.79,
    fontFamily: "Arial"
  }, "\n        Big_Stone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 137.66,
    width: 27.73,
    height: 26.41,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.401666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 150.865,
    fontFamily: "Arial"
  }, "\n        Wilkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 164.07,
    width: 27.73,
    height: 27.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9085714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 177.75,
    fontFamily: "Arial"
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 191.43,
    width: 27.73,
    height: 27.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.518
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 205.225,
    fontFamily: "Arial"
  }, "\n        Grant\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 219.02,
    width: 27.73,
    height: 28.28,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.773
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 233.16000000000003,
    fontFamily: "Arial"
  }, "\n        Clearwater\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 247.3,
    width: 27.73,
    height: 31.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.621666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 262.805,
    fontFamily: "Arial"
  }, "\n        Norman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 278.31,
    width: 27.73,
    height: 37.38,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.1330769230769233
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 297,
    fontFamily: "Arial"
  }, "\n        Lac_Qui_Parle\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 315.69,
    width: 27.73,
    height: 38.9,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0811111111111114
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 335.14,
    fontFamily: "Arial"
  }, "\n        Pipestone\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 354.59,
    width: 27.73,
    height: 39.23,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.621666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 374.205,
    fontFamily: "Arial"
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 393.82,
    width: 27.73,
    height: 40.17,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 413.905,
    fontFamily: "Arial"
  }, "\n        Rock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 433.99,
    width: 27.73,
    height: 41.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.46625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 454.975,
    fontFamily: "Arial"
  }, "\n        Watonwan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 475.96,
    width: 27.73,
    height: 43.67,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.46625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 497.79499999999996,
    fontFamily: "Arial"
  }, "\n        Marshall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.63,
    width: 27.73,
    height: 43.76,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9614285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 541.51,
    fontFamily: "Arial"
  }, "\n        Stevens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.39,
    width: 27.73,
    height: 44.92,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 585.85,
    fontFamily: "Arial"
  }, "\n        Pope\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.32,
    width: 27.73,
    height: 45.08,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.546
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 630.86,
    fontFamily: "Arial"
  }, "\n        Swift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.4,
    width: 27.73,
    height: 46.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8486666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.865,
    y: 676.6999999999999,
    fontFamily: "Arial"
  }, "\n        Yellow_Medicine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 0,
    width: 33.11,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7299999999999995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 44.285,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60.84,
    y: 0,
    width: 33.3,
    height: 39.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.757142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 77.49000000000001,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Kanabec\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.14,
    y: 0,
    width: 33.66,
    height: 39.41,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.97,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.81,
    y: 0,
    width: 33.68,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.368
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 144.65,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Pennington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.48,
    y: 0,
    width: 33.88,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.646666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 178.42,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Wadena\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.36,
    y: 0,
    width: 35.04,
    height: 39.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 212.88000000000002,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Chippewa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.41,
    y: 0,
    width: 35.22,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.522
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 248.01999999999998,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Cottonwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.63,
    y: 0,
    width: 38.05,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.341666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.655,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Sibley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.68,
    y: 0,
    width: 38.49,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.415
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 322.925,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Roseau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 342.17,
    y: 0,
    width: 39.53,
    height: 39.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5827272727272725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 361.935,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Koochiching\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.7,
    y: 0,
    width: 40.03,
    height: 39.41,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5683333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.715,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Aitkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 421.73,
    y: 0,
    width: 42.22,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 442.84000000000003,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.95,
    y: 0,
    width: 45.48,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.69,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Hubbard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.43,
    y: 0,
    width: 47.2,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.03,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Redwood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 556.64,
    y: 0,
    width: 47.24,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.92625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 580.26,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Renville\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 603.87,
    y: 0,
    width: 47.69,
    height: 39.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5683333333333325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 627.715,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Waseca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.57,
    y: 0,
    width: 48.43,
    height: 39.41,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.378888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.7850000000001,
    y: 19.705,
    fontFamily: "Arial"
  }, "\n        Faribault\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 39.41,
    width: 49.9,
    height: 38.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8289999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 58.55499999999999,
    fontFamily: "Arial"
  }, "\n        Mille_Lacs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 77.7,
    width: 49.9,
    height: 41.53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.921666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 98.465,
    fontFamily: "Arial"
  }, "\n        Nobles\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 119.23,
    width: 49.9,
    height: 42.73,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.104285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 140.595,
    fontFamily: "Arial"
  }, "\n        Wabasha\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 161.96,
    width: 49.9,
    height: 43.71,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.244285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 183.815,
    fontFamily: "Arial"
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 205.67,
    width: 49.9,
    height: 44.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.346666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 227.70999999999998,
    fontFamily: "Arial"
  }, "\n        Meeker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 249.76,
    width: 49.9,
    height: 44.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 272.05,
    fontFamily: "Arial"
  }, "\n        Fillmore\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 294.34,
    width: 49.9,
    height: 45.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 316.955,
    fontFamily: "Arial"
  }, "\n        Pine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 339.56,
    width: 49.9,
    height: 46.44,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 362.78,
    fontFamily: "Arial"
  }, "\n        Todd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 386.01,
    width: 49.9,
    height: 48.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.093333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 410.28999999999996,
    fontFamily: "Arial"
  }, "\n        Martin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 434.56,
    width: 49.9,
    height: 50,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.2375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 459.56,
    fontFamily: "Arial"
  }, "\n        Le_Sueur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 484.56,
    width: 49.9,
    height: 51.02,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 510.07,
    fontFamily: "Arial"
  }, "\n        Cass\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 535.58,
    width: 49.9,
    height: 51.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 561.355,
    fontFamily: "Arial"
  }, "\n        Lyon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 587.12,
    width: 49.9,
    height: 55.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.316666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 615.07,
    fontFamily: "Arial"
  }, "\n        Isanti\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.73,
    y: 643.03,
    width: 49.9,
    height: 56.97,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 52.68,
    y: 671.515,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 39.41,
    width: 50.96,
    height: 56.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.493333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.11,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Becker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.59,
    y: 39.41,
    width: 53.45,
    height: 56.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.908333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.315,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Benton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.04,
    y: 39.41,
    width: 53.71,
    height: 56.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.71375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 208.89499999999998,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Morrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 235.75,
    y: 39.41,
    width: 54.85,
    height: 56.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.835714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 263.175,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Carlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 290.6,
    y: 39.41,
    width: 55.54,
    height: 56.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.885
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 318.37,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.15,
    y: 39.41,
    width: 55.93,
    height: 56.11,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.99125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 374.11499999999995,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Nicollet\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.08,
    y: 39.41,
    width: 57.08,
    height: 56.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 430.62,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        McLeod\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 459.16,
    y: 39.41,
    width: 58.72,
    height: 56.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.351666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 488.52000000000004,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Steele\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.89,
    y: 39.41,
    width: 58.98,
    height: 56.11,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.015714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 547.38,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 576.87,
    y: 39.41,
    width: 59.46,
    height: 56.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.01375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 606.6,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Beltrami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 636.33,
    y: 39.41,
    width: 63.67,
    height: 56.11,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.015714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 668.1650000000001,
    y: 67.465,
    fontFamily: "Arial"
  }, "\n        Chisago\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 95.52,
    width: 66.88,
    height: 55.58,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 123.31,
    fontFamily: "Arial"
  }, "\n        Freeborn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 151.1,
    width: 66.88,
    height: 61.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.815555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 181.76999999999998,
    fontFamily: "Arial"
  }, "\n        Kandiyohi\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 212.44,
    width: 66.88,
    height: 63.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 243.97,
    fontFamily: "Arial"
  }, "\n        Mower\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 275.5,
    width: 66.88,
    height: 65.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.836666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 308.01,
    fontFamily: "Arial"
  }, "\n        Itasca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 340.53,
    width: 66.88,
    height: 66.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.472857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 373.68499999999995,
    fontFamily: "Arial"
  }, "\n        Goodhue\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 406.84,
    width: 66.88,
    height: 68.15,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.431111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 440.91499999999996,
    fontFamily: "Arial"
  }, "\n        Sherburne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 474.99,
    width: 66.88,
    height: 73.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 511.62,
    fontFamily: "Arial"
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 548.25,
    width: 66.88,
    height: 75.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 585.87,
    fontFamily: "Arial"
  }, "\n        Rice\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.63,
    y: 623.49,
    width: 66.88,
    height: 76.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 111.07,
    y: 661.745,
    fontFamily: "Arial"
  }, "\n        Winona\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 95.52,
    width: 59.34,
    height: 86.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.18,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Crow_Wing\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.85,
    y: 95.52,
    width: 64.34,
    height: 86.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.723333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.01999999999998,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Carver\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268.19,
    y: 95.52,
    width: 64.5,
    height: 86.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.44,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Otter_Tail\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.69,
    y: 95.52,
    width: 67.34,
    height: 86.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.734
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.36,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Blue_Earth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.03,
    y: 95.52,
    width: 77.91,
    height: 86.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.581999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 438.98499999999996,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Scott\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 477.94,
    y: 95.52,
    width: 85.03,
    height: 86.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.171666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 520.455,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Wright\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.97,
    y: 95.52,
    width: 137.03,
    height: 86.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.328571428571427
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.485,
    y: 138.67,
    fontFamily: "Arial"
  }, "\n        Olmsted\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 181.81,
    width: 154.52,
    height: 80.14,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.448571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.76999999999998,
    y: 221.88,
    fontFamily: "Arial"
  }, "\n        Stearns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 261.96,
    width: 154.52,
    height: 115.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.547
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.76999999999998,
    y: 319.695,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 377.43,
    width: 154.52,
    height: 146.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.360000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.76999999999998,
    y: 450.91,
    fontFamily: "Arial"
  }, "\n        Saint_Louis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.51,
    y: 524.4,
    width: 154.52,
    height: 175.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 30.904000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 221.76999999999998,
    y: 612.1999999999999,
    fontFamily: "Arial"
  }, "\n        Anoka\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 181.81,
    width: 154,
    height: 212.87,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.666666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.03,
    y: 288.245,
    fontFamily: "Arial"
  }, "\n        Dakota\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453.03,
    y: 181.81,
    width: 246.97,
    height: 212.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 35.47833333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 576.515,
    y: 288.245,
    fontFamily: "Arial"
  }, "\n        Ramsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.03,
    y: 394.68,
    width: 400.97,
    height: 305.32,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 38.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 499.515,
    y: 547.34,
    fontFamily: "Arial"
  }, "\n        Hennepin\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1992);
export default __webpack_public_path__ + "static/media/1992.b7b151e97b856c0f3645cb4820e65bd1.svg";
export { ForwardRef as ReactComponent };